<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">
    <v-row>
      <v-col>
        <v-text-field
          hide-details="auto"
          label="* Title"
          dense
          outlined
          v-model="formData.title"
          :rules="[$formRules.required]"
        />
      </v-col>

      <v-col cols="12" align="end">
        <v-btn
          color="secondary"
          class="mr-2"
          depressed
          :disabled="!valid"
          :loading="loading"
          type="submit"
        >
          Save
        </v-btn>

        <v-btn color="secondary" text @click="cancel">Cancel</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TaskCreateEditForm',
  props: {
    projectId: {
      type: Number,
      required: true
    },
    taskList: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    formData: {
      title: ''
    }
  }),
  methods: {
    ...mapActions('taskLists', ['storeTaskList', 'updateTaskList']),
    setFormDefaults() {
      this.formData = {
        title: this.taskList ? this.taskList.title : ''
      }
    },
    submit() {
      this.loading = true

      if (this.taskList && this.taskList.id) {
        this.updateTaskList({
          id: this.taskList.id,
          project_id: this.projectId,
          ...this.formData
        }).then(() => {
          this.loading = false

          this.cancel()
        })
      } else {
        this.storeTaskList({
          project_id: this.projectId,
          ...this.formData
        }).then(() => {
          this.loading = false

          this.cancel()
        })
      }
    },
    cancel() {
      this.$refs.form.reset()

      this.$nextTick(() => {
        this.setFormDefaults()
      })

      this.$emit('cancel')
    }
  },
  created() {
    this.setFormDefaults()
  }
}
</script>
